module.exports = __webpack_public_path__ + "img/newspaper.d55afb30.svg";